import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './alert_icon.scss';

const AlertIcon = props => {
  const { condition, iconClassName, onNavigation, title, wrapperClassName } = props;

  return (
    condition && (
      <div
        className={classnames('alert-icon__wrapper', wrapperClassName, {
          'alert-icon--on-navigation': onNavigation,
        })}
      >
        <div className={classnames('alert-icon icon-exclamation', iconClassName)} title={title} />
      </div>
    )
  );
};

AlertIcon.propTypes = {
  condition: PropTypes.bool,
  iconClassName: PropTypes.string,
  title: PropTypes.string,
  wrapperClassName: PropTypes.string,
};

AlertIcon.defaultProps = {
  condition: false,
};

export default AlertIcon;
